import { PhoneNumbersService } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-numbers/phone_numbers_service.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaBlockedNumberService = bindHTTP(PhoneNumbersService);
export { SchemaBlockedNumberService };
